export enum AuthStatus {
  LOADING = "loading",
  AUTHENTICATING = "authenticating",
  AWAITING_AUTHORIZATION = "awaiting-authorization",
  SUCCESS = "success",
  ERROR = "error",
}
